<div class="container_dati_generali">
  <div class="row">
    <div labelTextInput class="col-sm-4 bloccodati"
      [typeLabel]="'text'"
      [labelInput]="'Causale'"
      [valueInput]="pagamento.causale"></div>
      <div labelTextInput class="col-sm-4 bloccodati"
      [typeLabel]="'importo'"
      [labelInput]="'Importo'"
      [valueInput]="pagamento.importo"></div>
    <div labelTextInput class="col-sm-4 bloccodati"
      [typeLabel]="'text'"
      [labelInput]="'Stato'"
      [valueInput]="pagamento.stato"></div>
  </div>
  <div class="row">
      <div labelTextInput class="col-sm-4 bloccodati"
      [typeLabel]="'text'"
      [labelInput]="'Nominativo Soggetto Pagatore'"
      [valueInput]="pagamento.nominativoSoggettoPagatore"></div>
      <div labelTextInput class="col-sm-4 bloccodati"
      [typeLabel]="'date'"
      [labelInput]="'Data Richiesta'"
      [valueInput]="pagamento.dataRichiesta"></div>
    <div *ngIf="hasRicevuta()" labelTextInput class="col-sm-4 bloccodati"
      [typeLabel]="'date'"
      [labelInput]="'Data Ricevuta'"
      [valueInput]="pagamento.dataRicevuta"></div>
  </div>
  <div class="row" *ngIf="!hasRicevuta()">
    <!-- pulsante Scarica Avviso o Scarica Ricevuta -->
    <div  class="col-xs-6 col-sm-4 col-sm-offset-8 col-xs-offset-6">
      <button class="btn btn-primary search" type="submit" aria-label="Scarica Avviso" (click)="onDownloadAvviso()">Scarica Avviso</button>
    </div>
  </div>
  <div class="row" *ngIf="hasRicevuta()">
    <div class="col-xs-6 col-sm-4">
      <button class="btn btn-primary search" type="submit" aria-label="Scarica Ricevuta" (click)="onDownloadRicevuta('XML')">Scarica l'XML di Ricevuta</button>
    </div>
    <div class="col-xs-6 col-sm-4 col-sm-offset-4">
      <button class="btn btn-primary search" type="submit" aria-label="Scarica Ricevuta" (click)="onDownloadRicevuta('PDF')">Scarica il PDF di Ricevuta</button>
    </div>
</div>
